import React from 'react';
import FeatureMobileHeader from './FeatureMobileHeader';

// Wraps the mobile render of a feature page with v2 chrome:
// fhv2-mpage dark ground, back-button header + title + optional
// right action, and an optional editorial serif italic lead.
// Children are the existing functional body.
interface Props {
  title: string;
  rightIcon?: string;
  onRight?: () => void;
  lead?: React.ReactNode;          // e.g. <>5 lists, <em>34 items.</em><span className="sub">sub</span></>
  children: React.ReactNode;
}

const FeatureMobileShell: React.FC<Props> = ({ title, rightIcon, onRight, lead, children }) => (
  <div className="fhv2-mpage" style={{ paddingBottom: 'calc(var(--fh-nav-height, 72px) + env(safe-area-inset-bottom, 0px) + 32px)' }}>
    <FeatureMobileHeader title={title} rightIcon={rightIcon} onRight={onRight} />
    {lead ? <div className="fhv2-mlead2">{lead}</div> : null}
    {children}
  </div>
);

export default FeatureMobileShell;
